import {
  createSlice,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loading",

  initialState: {
    pendingRequests: 0,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addMatcher(isPending, (state) => {
        state.pendingRequests += 1;
      })

      .addMatcher(isFulfilled, (state) => {
        state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      })

      .addMatcher(isRejected, (state) => {
        state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      });
  },
});

export default loadingSlice.reducer;
